{ avatarDomain } = require '@trello/config'
t = require('app/scripts/views/internal/teacup-with-helpers')('member_large_avatar')

module.exports = t.renderable ({ avatarHash, viewTitle, avatarSource }) ->
  title = viewTitle
  className = ''
  if avatarSource == 'atlassianAccount'
    className = "pop-over-atlassian-account-avatar"
  t.img { src: [avatarDomain, avatarHash, 'original.png'].join('/'), class: className, alt: title, title }
